import RequestAbstract from "./RequestAbstract";

export default class DocumentTemplate extends RequestAbstract {
    get link() {
        return this.links.documentTemplate;
    }

    getDocument() {

        const arr = [
            { field: "hidden", op: "=", value: false },
            { field: "jasperReportId", op: "!=", value: null },
            { field: "name", op: "!=", value: "" }
        ];

        return this.getAllFiltered([arr], this.getSortField("-title"));
    }

}
